import { render, staticRenderFns } from "./VitalsDetail.vue?vue&type=template&id=cb585734&"
import script from "./VitalsDetail.vue?vue&type=script&lang=js&"
export * from "./VitalsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports